module.exports = __webpack_public_path__ + "static/media/pixeled-token-selector-white.39ce5a60.svg";